module.exports = __webpack_public_path__ + "static/media/sugar_rush_1000.pragmaticplay.569f0fcb.jpeg";